"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrayOfCount = getArrayOfCount;
function getArrayOfCount(length) {
    return Array.from({ length })
        .fill(null)
        .map((_, index) => index);
}
